export const RevolutPayIcon = () => {
	return (
		<svg
			width="32"
			height="32"
			viewBox="0 0 32 32"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<rect width="32" height="32" rx="2" fill="#191C1F" />
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M11.7254 10.9357H8V25.9999H11.7254V10.9357ZM23.408 11.7971C23.408 8.60061 20.805 6 17.6054 6H8V9.21707H17.1486C18.5967 9.21707 19.7961 10.3547 19.8227 11.7528C19.8359 12.4529 19.5731 13.1137 19.0828 13.6133C18.5923 14.113 17.937 14.3885 17.2375 14.3885H13.6736C13.547 14.3885 13.4441 14.4913 13.4441 14.6178V17.477C13.4441 17.5257 13.4591 17.5722 13.4873 17.6113L19.534 26H23.9602L17.8995 17.5884C20.9517 17.4351 23.408 14.8707 23.408 11.7971Z"
				fill="white"
			/>
		</svg>
	);
};
